import { useSubscriptionStore } from '~/stores/subscription';

export default defineNuxtPlugin((nuxtApp) => {
  const subscriptionStore = useSubscriptionStore(nuxtApp.$pinia);

  const subscribedCookie = useCookie('subscribed');

  if (subscribedCookie?.value) {
    subscriptionStore.setSubscribed(subscribedCookie.value, false);
  }
});
